<template>
  <div id="smallshop-footer">
    <ul>
      <router-link tag="li" v-for="item in tabbars" :key="item.id" :to="item.path">
        <img class="tabbarImg" v-if="!item.active" :src="item.icon" alt="">
        <img class="tabbarImg" v-else :src="item.iconActive" alt="">
        <span>{{ item.text }}</span>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  name: "TabBarSmallShop",
  watch: {
    '$route': {
      handler() {
        console.log(this.$route.path)
        if (this.$route.path == '/smallShop/home') {
          this.tabbars[0].active = true
          this.tabbars[1].active = false
          this.tabbars[2].active = false
          return
        }
        if (this.$route.path == '/smallShop/order') {
          this.tabbars[0].active = false
          this.tabbars[1].active = true
          this.tabbars[2].active = false
          return
        }
        if (this.$route.path == '/smallShop/mine') {
          this.tabbars[0].active = false
          this.tabbars[1].active = false
          this.tabbars[2].active = true
          return
        }
      },
      deep: true,
      immediate: true,
    }
  },
  data() {
    return {
      tabbars: [
        {
          id: 0,
          text: "产品中心",
          icon: require("@assets/image/tabbar20.png"),
          iconActive: require("@assets/image/tabbar22.png"),
          path: "/smallShop/home",
          active: true
        },
        {
          id: 1,
          text: "订单",
          icon: require("@assets/image/tabbar52.png"),
          iconActive: require("@assets/image/tabbar53.png"),
          path: "/smallShop/order",
          active: false
        },
        {
          id: 2,
          text: "我的",
          icon: require("@assets/image/tabbar40.png"),
          iconActive: require("@assets/image/tabbar42.png"),
          path: "/smallShop/mine",
          active: false
        }
      ]
    };
  },
  mounted() {
    // 初始化时可以添加其他逻辑
  },
  methods: {
    // 可以添加其他方法
  }
};
</script>

<style lang="scss">
#smallshop-footer {
  width: 100%;
  padding: .1rem 0 .2rem;
  position: fixed;
  left: 0;
  bottom: 0;
  background: linear-gradient(180deg, #FAEEDC 0%, #FFEDD3 100%);
  z-index: 103;
  border-top: 0.01rem solid #f1f1f1;
}

#smallshop-footer ul {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#smallshop-footer ul li {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

#smallshop-footer ul li span {
  font-size: .2rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #464646;
}

#smallshop-footer ul li img {
  width: .48rem;
  height: .48rem;
}

#smallshop-footer ul .router-link-active {
  span {
    color: #9C5817;
  }
}
</style>
